import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const TimeLogs = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { TimeLogs, defaultState };
